import core from './core';

export function getAlerts(user_id: any) {
  return core.get(`/api/2/adminsetting/alert/notification?user_id=${user_id}`).then(({data}) => data);
}

export function postAlerts({fd}: any) {
  return core.post('/api/2/adminsetting/alert/notification', fd).then(({data}) => data);
}
